import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { NzPlacementType } from 'ng-zorro-antd/dropdown';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-frame-comment-admin-config',
  templateUrl: './frame-comment-admin-config.component.html',
  styleUrls: ['./frame-comment-admin-config.component.scss']
})
export class AtwFrameCommentAdminConfig extends AtwUpdateDbComponent implements OnInit {
@Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() type: any; // xem đang ở page hay admin
  @Output() changeOptionConfig = new EventEmitter<any>();
  
  isViewAll: boolean = false;
  isCollapsed: boolean = false;
  positionSelect: NzPlacementType = 'bottomCenter';
  dataConfig: any;
  dataAfterChange: any = {};
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
    {
      title: 'dieu_chinh_hieu_ung',
      index: 3,
    },
  ];
  public optionsBackground = [
    {
      label: 'hinh_nen',
      value: 'image',
    },
    {
      label: 'mau_nen',
      value: 'color',
    },
  ];
  public cols: any = [1, 2, 3, 4, 6];
  openBorderConfig: boolean = false;
  public bootstrapIconArrows: any = [
    {
      icon_left: 'bi bi-chevron-left',
      icon_right: 'bi bi-chevron-right',
    },
    {
      icon_left: 'bi bi-arrow-left-short',
      icon_right: 'bi bi-arrow-right-short',
    },
    {
      icon_left: 'bi bi-caret-left-fill',
      icon_right: 'bi bi-caret-right-fill',
    },
    {
      icon_left: 'bi bi-chevron-compact-left',
      icon_right: 'bi bi-chevron-compact-right',
    },
  ];

  fonts = [];
  effect_hover = [];
  customize = [];
  configMode: 'basic' | 'advanced' = 'basic';


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    this.initData();

    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/frame-products.json'),
    ]).subscribe(([fonts, effects]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
    });
  }

  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`;
  };

  /** Hàm này thực hiện khởi tạo dữ liệu;
   *
   */
  initData() {
    if (this.objectChoosing && this.device) {
      this.dataConfig = this.objectChoosing[`${this.device}_config`];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.objectChoosing) {
        this.initData();
      }
      if (changes.device) this.device = changes.device.currentValue;
    }
  }

  /**
   * Xử lí thay đổi số cột
   */
  handleChangeCols() {
    // this.class['frame-comment__list']['grid-template-columns'] = `repeat(${this.dataConfig.cols}, minmax(0px, 1fr))`;
    // cập nhật trường grid-template-columns
    this.class['frame-comment__list'][
      'grid-template-columns'
    ] = `repeat(${this.config['cols']},${this.calcSpaceGrid(
      this.config.cols
    )})`;

    // cập nhật trường grid-template-rows
    this.class['frame-comment__list'][
      'grid-template-rows'
    ] = `repeat(${this.config.rows},${this.calcSpaceGrid(this.config.rows)})`;

    // Cập nhật tường grid-auto-columns
    this.class['frame-comment__list'][
      'grid-auto-columns'
    ] = `${this.calcSpaceGrid(this.config.cols)}`;

    this.config['total_comments'] = this.config['cols'] * this.config['rows'];
  }

  /**
   * Xử lí thay đổi số dòng
   */
  handleChangeRows() {
    // this.class['frame-comment__list']['grid-template-rows'] = `repeat(${this.dataConfig.rows}, minmax(0px, 1fr))`;
    this.class['frame-comment__list'][
      'grid-template-rows'
    ] = `repeat(${this.config.rows},${this.calcSpaceGrid(this.config.rows)})`;
    this.config['total_comments'] = this.config['cols'] * this.config['rows'];
  }
  /** Hàm này trả về một chuỗi để chia layout cho grid
   * @param cols
   * @param gap
   *
   * @example
   * cols = 4
   * gap = 12
   * Kết quả: calc(25% - 9px)
   * @return calc(${100/cols}% - ${(gap/cols)*(cols-1)}px)
   *
   */
  calcSpaceGrid(cols) {
    let gap = parseInt(this.class['frame-comment__list'].gap, 10);
    return `calc(${100 / cols}% - ${(gap / cols) * (cols - 1)}px)`;
  }

  /** Hàm thực hiện xử lý font-size icon left
   *
   * @param event
   */
  handleFontSizeIconLeft(event) {
    let value = `${event}px`;
    this.class['frame-comment__left-arrow--icon']['font-size'] =
      this.class['frame-comment__left-arrow--icon']['height'] =
      this.class['frame-comment__left-arrow--icon']['width'] =
        value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý font-size icon right
   *
   * @param event
   */
  handleFontSizeIconRight(event) {
    let value = `${event}px`;
    this.class['frame-comment__right-arrow--icon']['font-size'] =
      this.class['frame-comment__right-arrow--icon']['height'] =
      this.class['frame-comment__right-arrow--icon']['width'] =
        value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon trái cách bên trái
   *
   * @param event
   */
  handleLeftArrowLeft(event) {
    let value = `${event}%`;
    this.class['frame-comment__left-arrow']['left'] = value;
    this.updateClass();
  }
  /** Hàm thực hiện xử lý icon phải cách bên phải
   *
   * @param event
   */
  handleRightArrowRight(event) {
    let value = `${event}%`;
    this.class['frame-comment__right-arrow']['right'] = value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon trái cách bên trên
   *
   * @param event
   */
  handleTopArrowLeft(event) {
    let value = `${event}%`;
    this.class['frame-comment__left-arrow']['top'] = value;
    this.updateClass();
  }

  /** Hàm thực hiện xử lý icon phải cách bên trên
   *
   * @param event
   */
  handleTopArrowRight(event) {
    let value = `${event}%`;
    this.class['frame-comment__right-arrow']['top'] = value;
    this.updateClass();
  }

  // updateConfig() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_config']: this.config,
  //       // data: this.data
  //     })
  //     .then((bool: any) => {});
  // }

  // updateClass() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_class']: this.class,
  //     })
  //     .then((bool: any) => {});
  // }

  // updateStaticData() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       staticdata: this.objectChoosing.staticdata,
  //     })
  //     .then((bool: any) => {});
  // }

  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu14: false,
  };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  openBgColor() {
    document.getElementById('input-color').click();
  }

  /*--------- Thay đổi mũi tên điều hướng trang -------------------*/
  onChangeArrows(arrows) {
    this.dataConfig.icon_pagination.arrow_left_icon = arrows.icon_left;
    this.dataConfig.icon_pagination.arrow_right_icon = arrows.icon_right;
    this.updateConfig();
  }

  // //Hàm update position
  // updatePosition() {
  //   this.vhQueryAutoWeb
  //     .updateBlock(this.objectChoosing._id, {
  //       [this.device + 'position']: this.position,
  //     })
  //     .then((bool: any) => {});
  // }

  // PHẦN DOTS - Nút phân trang

  /**
   * Kiểu nút slide
   * @param event
   */
  handleSetDotsStyle(event) {
    switch (event) {
      case 'circle':
        this.class['frame-comment__pagination-list-button--controll'][
          'border-radius'
        ] = 50 + 'px';
        this.class[
          'frame-comment__pagination-list-button--page-number'
        ]['border-radius'] = 50 + 'px';
        this.class['frame-comment__pagination-list-button--active'][
          'border-radius'
        ] = 50 + 'px';
        this.config[`slick_dots`]['height'] =
          this.config[`slick_dots`]['width'];
        break;
      case 'rectangle':
        this.class['frame-comment__pagination-list-button--controll'][
          'border-radius'
        ] = 0 + '%';
        this.class[
          'frame-comment__pagination-list-button--page-number'
        ]['border-radius'] = 0 + '%';
        this.class['frame-comment__pagination-list-button--active'][
          'border-radius'
        ] = 0 + '%';
        break;
    }

    this.updateConfig();
    this.updateClass();
  }

  /**
   * Kích thước cho nút next/prev
   *  @param event
   *  @param type nút next hay prev
   */
  handleSetButtonSize(event) {
    var style = this.config[`slick_dots`]['background_style'];

    this.config[`slick_dots`]['width'] = event + 'px';
    this.config['slick_dots']['height'] = event + 'px';
    this.class['frame-comment__pagination-list-button--controll'][
      'border-radius'
    ] = 50 + 'px';
    this.class['frame-comment__pagination-list-button--page-number'][
      'border-radius'
    ] = 50 + 'px';
    this.class['frame-comment__pagination-list-button--active'][
      'border-radius'
    ] = 50 + 'px';
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[2]);
  }
}
